import React from "react";
import BlueHeading from "../other/common/BlueHeading";
import Heading from "../common/ui/Heading";
import magnaticList from "../../assets/images/webp/mangnetic-devices.webp";
import aboutBrandImg from "../../assets/images/webp/about-brand-img.webp";
const Hydration = () => {
  return (
    <>
      <div className="py-[140px] px-4 max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-16">
        <div className="max-w-[1140px] mx-auto flex items-center max-xl:gap-7 max-lg:flex-wrap-reverse justify-between">
          <div className="w-full max-w-[457px] max-lg:max-w-full">
            <BlueHeading lineClassOne="!hidden" text="Vital Hydration" />
            <Heading children="About The Brand" />
            <p className="text-[#5E5C5C] font-normal text-base leading-[150%] pt-4">
              Jeena Sikho INJK Technique Magnetic Water Device is a
              revolutionary innovation crafted to enhance everyday health and
              wellness among mankind. This user-friendly manual device
              transforms regular water into alkaline water by infusing essential
              minerals and antioxidants ensuring every sip enhances a healthy
              and balanced lifestyle. This innovative device features specially
              selected mineral pebbles inside, that naturally enrich your water
              with essential antioxidants and vital minerals as it flows
              through, transforming ordinary water into vital mineral and
              antioxidant rich alkaline water.
            </p>
            <img
              src={magnaticList}
              alt="magnatic"
              className="w-full max-w-[456px] pt-[48px] max-lg:pt-7"
            />
          </div>
          <div className="w-full max-w-[606px] max-lg:max-w-full">
            <img
              src={aboutBrandImg}
              alt="brand"
              className="w-full pointer-events-none"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Hydration;
